/**
 * Opening a PDF in a new tab from a button that first asks the server (T07-42 review).
 *
 * Safari / iPadOS — above all a PWA added to the home screen — blocks `window.open` that runs
 * after an awaited request: it is no longer inside the user's tap. So the tab is opened **in the
 * tap** (blank), then pointed at the link when it arrives, or closed when there is nothing to
 * show. `noopener` cannot be passed (the tab could not be pointed later) — `opener` is cut by hand.
 */
export interface PendingTab {
  /** Show `url` in the tab opened in the tap; false when no tab could be opened. */
  show(url: string): boolean;
  /** Nothing to show after all (the PDF is still being made / an error). */
  close(): void;
}

export function openTabInTap(): PendingTab {
  const tab = window.open("", "_blank");
  if (tab) {
    tab.opener = null;
  }
  return {
    show(url) {
      if (!tab || tab.closed) {
        return false;
      }
      tab.location.href = url;
      return true;
    },
    close() {
      tab?.close();
    },
  };
}
